import React, { cloneElement, useState } from "react";

// Lightweight CSS-positioned tooltip. Wraps a single focusable child element.
// Usage: <Tooltip label="Close"><button>...</button></Tooltip>
export default function Tooltip({ label, children, side = "bottom", delay = 150, className = "" }) {
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState(null);

  const show = () => {
    if (timer) clearTimeout(timer);
    const t = setTimeout(() => setOpen(true), delay);
    setTimer(t);
  };
  const hide = () => {
    if (timer) clearTimeout(timer);
    setTimer(null);
    setOpen(false);
  };

  const pos = {
    bottom: "top-full mt-1.5 left-1/2 -translate-x-1/2",
    top: "bottom-full mb-1.5 left-1/2 -translate-x-1/2",
    left: "right-full mr-1.5 top-1/2 -translate-y-1/2",
    right: "left-full ml-1.5 top-1/2 -translate-y-1/2",
  }[side];

  return (
    <span
      className={`relative inline-flex ${className}`}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      {cloneElement(children, { "aria-label": children.props["aria-label"] || label })}
      {open && (
        <span
          role="tooltip"
          className={`pointer-events-none absolute z-[60] whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-[11px] font-medium text-white shadow-md ${pos}`}
        >
          {label}
        </span>
      )}
    </span>
  );
}
